import { PreserveSearchNavigate } from "../../components/Navigate/PreserveSearchNavigate.tsx";
import { Spinner } from "../../components/Spinner/Spinner.tsx";
import { WORKSPACES } from "../../routes.ts";
import { useUser } from "../hooks/useUser.ts";
import { useLastSelectedWorkspaceUuid } from "../Workspace/hooks/useLastSelectedWorkspaceUuid.ts";
import { useModelUuid } from "./hooks/useModelUuid.ts";

export const ModelRedirect = () => {
  const { user } = useUser();
  const modelUuid = useModelUuid();
  const lastSelectedWorkspaceUuid = useLastSelectedWorkspaceUuid();
  if (!user) return <Spinner />;

  return (
    <PreserveSearchNavigate
      replace
      to={`${WORKSPACES}/${
        lastSelectedWorkspaceUuid ?? user.workspaces[0].uuid
      }/references/${modelUuid}`}
    />
  );
};
